<div class="content">
	<div class="content-box" style="width: {{ width }}; padding: {{ contentBoxPadding }}">
		<ic-change-language />
		<div class="block-content">
			<div class="image" [class.center]="isCenteredLogo" [class.start]="!isCenteredLogo">
				<img alt="CareConnect Into.Care" src="assets/images/logo_CC-intocare_HOR.png" />
			</div>
			<ng-content />
		</div>
	</div>
</div>

<a class="contact" href="{{ 'support.contactUrl' | translate }}" target="_blank">
	<i class="fa fa-envelope"></i>{{ "auth.contact" | translate }}
</a>

<ng-template #invalidBrowserTmpl>
	<div class="browserWarning">
		<div class="warning-title">
			<i aria-hidden="true" class="fa fa-exclamation-circle"></i>
			<h1>{{ "environment.invalidBrowser.title" | translate }}</h1>
		</div>

		<p>{{ "environment.invalidBrowser.description" | translate }}</p>
	</div>
</ng-template>
